import React from "react";
import { NavLink } from "react-router-dom";

// Компонент для відображення навігаційного меню в верхньому модальному вікні
const NavBarModal = ({
  items,
  groups,
  closeModal,
  children,
  contentClassName = "",
}) => {
  return (
    <div id="navbar-modal" onClick={closeModal}>
      <div
        className={`modal-content ${contentClassName}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Логіка для згрупованих посилань (Таблиці) */}
        {groups && groups.length > 0 ? (
          <div className="nav-groups-wrapper">
            {groups.map((group) => (
              <div key={group.title} className="nav-group">
                <h4 className="nav-group-title">{group.title}</h4>
                <ul>
                  {group.items.map((item) => (
                    <li key={item.path}>
                      <NavLink to={item.path} onClick={closeModal}>
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          /* Логіка для звичайного списку (Аналітика, Налаштування, Профіль) */
          <ul>
            {items &&
              items.map((item) => (
                <li key={item.path}>
                  <NavLink to={item.path} onClick={closeModal}>
                    {item.label}
                  </NavLink>
                </li>
              ))}
            {children && <li>{children}</li>}
          </ul>
        )}
      </div>
    </div>
  );
};

export default NavBarModal;
